var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6799 8.4C14.6799 9.46 14.3799 10.45 13.8299 11.29C13.7899 11.37 13.7399 11.44 13.6899 11.51C12.7299 12.89 11.1199 13.8 9.31995 13.8C6.35995 13.8 3.94995 11.38 3.94995 8.4C3.94995 5.42 6.35995 3 9.31995 3C11.1299 3 12.7399 3.91 13.6899 5.29C13.7399 5.36 13.7899 5.43 13.8299 5.52C14.3799 6.36 14.6799 7.35 14.6799 8.41V8.4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 8.40001C20.4998 10.6 18.7298 12.38 16.5498 12.38C15.4998 12.38 14.5498 11.97 13.8398 11.29C14.3898 10.45 14.6898 9.46001 14.6898 8.40001C14.6898 7.34001 14.3898 6.35001 13.8398 5.51001C14.5498 4.83001 15.4998 4.42001 16.5498 4.42001C18.7298 4.42001 20.4998 6.20001 20.4998 8.40001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21C6.11 16.58 12.46 16.56 15.1 20.95L15.13 21",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.16 20.1C18.74 18.64 17.74 17.5 16.48 17.01L17.67 15.82",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.25b9ecb0f4368ac8ca82e8fbeedae1ed.svg";
export { ForwardRef as ReactComponent };